<div class="toolbar">
  <div class="title">
    <img width="70" alt="MakingWaves Logo" src="assets/images/makingwaves_logo.png" />
    <span>עושה גלים</span>
    <div class="version">
      <span>{{version}}</span>
    </div>
  </div>

  @if (isAuthenticated()) {
    <div class="actions">
      <button mat-raised-button (click)="signOut()">Sign Out</button>
    </div>
  }
</div>